import { getObjectKeysAsObject, ParentState } from "@capone/checkout";

import { ActivityContext } from "../../../modules/book/state/types";

export const guards = {
  hasAdditionalDetailsStep: (ctx: ActivityContext) =>
    ctx[ParentState.activityAdditionalDetails].hasAdditionalDetailsStep,
};

export const GuardTypes = getObjectKeysAsObject(guards);
